module.exports = __webpack_public_path__ + "img/logo_fluxsolar.6af8e118.png";